import { AllDefectResponse, DefectResponse } from '@gtpl/shared-models/masters';
import { CommonResponse } from '@gtpl/shared-models/production-management';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post, Req } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { DefectService } from './defect.service';
import { DefectDto } from './dto/defect.dto';
import { DefectRequest } from './dto/defect.request';
import { UserRequestDto } from '@gtpl/shared-models/common-models';

@ApiTags('defect')
@Controller('defect')
export class DefectController {
    constructor(
        private defectService: DefectService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler,
    ) { }

    @Post('/createDefect')
    async createDefect(@Body() dto: DefectDto, @Req() request: Request): Promise<DefectResponse> {
        try {
            return await this.defectService.createDefect(dto, false, request);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(DefectResponse, error);
        }
    }

    @Post('/getAllDefects')
    async getAllDefects(@Body() req?:UserRequestDto): Promise<AllDefectResponse> {
        try {
            return await this.defectService.getAllDefects(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(AllDefectResponse, error);
        }
    }

    @Post('/activateOrDeactivateDefect')
    async activateOrDeactivateDefect(@Body() req: DefectRequest): Promise<DefectResponse> {
        try {
            return await this.defectService.activateOrDeactivateDefect(req);
        } catch (err) {
            return this.applicationExceptionHandler.returnException(DefectResponse, err);
        }
    }

    @Post('/updateDefect')
    async updateDefect(@Body() dto: DefectDto, @Req() request: Request): Promise<DefectResponse> {
        try {
            return await this.defectService.createDefect(dto, true, request);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(DefectResponse, error);
        }
    }

    @Post('/getAllActiveDefects')
    async getAllActiveDefects(): Promise<CommonResponse> {
        try {
            return await this.defectService.getAllActiveDefects();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }
}